// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"styles_closeButton__J3dEM","iframe":"styles_iframe__icixm","screenReaderOnly":"styles_screenReaderOnly__IdbF_"};